import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import { useState } from 'react';
import StudentUserTools from './StudentUserTools';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import StudentUserModel from './StudentUserModel';
import { useEffect } from 'react';
import { StudentUserDelete, StudentUserShowdata } from '../../services/LoginPageService';
import { Tooltip } from '@mui/material';
import DeleteConfirmationDailog from '../../utils/confirmDeletion';
import NotificationBar from '../notification/ServiceNotificationBar';

const StudentUserList = () => {
  const [rows,setRow]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editStudentUser, setEditStudentUser] = useState('');
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  
  const columns = [
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'branch',
      headerClassName: 'super-app-theme--header',
      headerName: 'Hostel Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'fullName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Username',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'email',
      headerClassName: 'super-app-theme--header',
      headerName: 'Email',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'phone',
      headerClassName: 'super-app-theme--header',
      headerName: 'Phono No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    
    {
      field: 'userRole',
      headerName: 'Designation',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      width: 250,
      cellClassName: 'actions',
      disableClickEventBubbling: true,
      getActions: (params) => [
        <EditData selectedRow={params.row} />, 
        <DeleteData selectedRow={params.row} />,  
      ],
    },
  ];

  useEffect(()=>{
    StudentUserShowdata(handleStudentUserShowdata,handleStudentUserShowdataException);
  },[refreshData])

  const handleStudentUserShowdata=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }

  const handleStudentUserShowdataException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }

  function EditData(props) {
    return (
      <Tooltip title="Edit">
        <EditIcon style={{cursor: 'pointer'}}
          onClick={(event) => {
            event.stopPropagation();
            setIsAddButton(false);
            setEditStudentUser(props.selectedRow);
            setOpen(true);
          }}
        />
      </Tooltip>
    );
  }
  
  function DeleteData(props) {
    return (
      <Tooltip title="Delete">
        <DeleteIcon style={{cursor: 'pointer'}}
            onClick={() => {
            setDeleteId(props.selectedRow.id);
            console.log(props.selectedRow.id);
            setDeleteDailogOpen(true); 
          }}
        />
      </Tooltip>
    );
  }

  const DeleteFunction =()=>{
    StudentUserDelete(handleDeleteSuccess,handleDeleteException);
  }

  const handleDeleteSuccess = (dataObject) =>{
    console.log(dataObject);
      setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    }); 
    setTimeout(()=>{
      setDeleteDailogOpen(false);
      }, 2000);
    setRefreshData(oldValue => !oldValue);
  }

  const handleDeleteException = (errorObject, message) =>{
    console.log(message);
    setNotification({
      status: true,
      type: 'error',
      message:message,
    });
  }

  const handleClose = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };

  return (
    <div style={{marginLeft:'10px'}}>
      <StudentUserTools
        setIsAddButton={setIsAddButton}
        editStudentUser={editStudentUser}
        setOpen={setOpen}
        setEditStudentUser={setEditStudentUser}   
      />
            
      <StudentUserModel
        isAddButton={isAddButton}
        editStudentUser={editStudentUser}
        setEditStudentUser={setEditStudentUser} 
        open={open}
        setOpen={setOpen}
        setRefreshData={setRefreshData}
        setNotification={setNotification}
      />

      <DeleteConfirmationDailog
        open={deleteDailogOpen}
        setOpen={setDeleteDailogOpen}
        deleteId={deleteId}
        deleteService={StudentUserDelete}
        handleSuccess={handleDeleteSuccess}
        handleException={handleDeleteException}
      />

       <NotificationBar
        handleClose={handleClose}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />

      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
        height: '480px',
        width: '100%',
        '& .super-app-theme--header': {
          WebkitTextStrokeWidth:'0.6px',
        },
        }}
      />
    </div>
  )
}

export default StudentUserList
